import $ from 'jquery';

// as simple a filter could be
if( $( '.js-styleMenu' ).length ) {

  const urlParams = new URLSearchParams(window.location.search);

  if( urlParams.size > 0 ) {
    const myParam = urlParams.get('cat');

    $( `.js-tagMenu label[data-tag='${ myParam }'] input` ).trigger( 'click' );

    categoryInputChange();
    urlReset();
  }

  
  // filter by News Type i.e story or event
  $( document ).on( 'click','.js-styleMenu a', function(e) {
    e.preventDefault();
    
    let type = $( this ).data( 'type' );
    
    $( '.js-type' ).each( function() {

      if( $( this ).data( 'type' ) == type || type == 'all' ){
        $( this ).show().addClass('order-last');
      } else {
        $( this ).hide().removeClass('order-last');
      }
    })
  })

  // on categories input radio change
  $( document ).on( 'change', '.js-tagMenu label input', function(e) {
    e.preventDefault();

    categoryInputChange();
  })

  $(document).on('click', '.js-button', () => {
    $('.show-card').removeClass('hidden');
    $('.js-button').hide();
  });

  function categoryInputChange() {
    // get array of checked values
    var checked = $("[name='categories']:checked").map( function() {
      return $(this).val();
    }).get();

    // loop over results
    $( '.js-tag' ).each( function() {
      
      let $this = $( this );
      let tag = $this.data( 'tag' )
      
      if (tag !== undefined) {
        // if result is in checked input array
        checked.includes(tag) ? $this.show() : $this.hide();
      }
    })
  }

  function urlReset() {
    const urlObj = new URL( window.location )

    urlObj.search = '';
    urlObj.hash = '';

    const result = urlObj.toString();

    window.history.pushState('', '', result);
  }
}
